import React, { useState, useRef, useEffect, useContext } from "react";
import axios from "axios";
import { BASELINE } from "../../../util";
import { motion } from "framer-motion";
import { FaAngleDoubleDown, FaComments } from "react-icons/fa";
import { IoIosSend } from "react-icons/io";
import { UserContext } from "../../../context/UserContext";
import PromotionModal from "../../../Components/popmodal";
import ScoreAnalysis from "./sat_graph";
import SATScoreAnalysis from "./satanalysis";
import SATPredictionAnalysis from "./satscore";
import SATScoreDisplay from "./mocksatscore";

const DashboardAI = ({
    subject,
    lastscore,
    avg_sat,
    averageMCQ,
    averageFRQ,
    esubjects,
    msubjects,
    aiquestion,
    mocksatreview,
    satanal,
}) => {
    const [messages, setMessages] = useState([]);
    const { user, aiid } = useContext(UserContext);

    const [modalOpen, setModalOpen] = useState(false);
    const [analai, setanalai] = useState("");
    const [aiplayed, setaiplayed] = useState(false); // Chat open/close
    const [initialAnalai, setInitialAnalai] = useState("");

    const [userin, setuserin] = useState("");
    const [showTooltip, setShowTooltip] = useState(false);
    const messageEndRef = useRef(null);
    // visual === 0 => 일반 텍스트 렌더링, visual === 1 => SATScoreAnalysis 컴포넌트로 렌더링
    const [visual, setvisual] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [currentResponse, setCurrentResponse] = useState(null);

    // Retrieve greeting flag from localStorage or default false
    const [hasGreeted, setHasGreeted] = useState(() => {
        return localStorage.getItem("hasGreeted") === "true";
    });

    const satData2024 = {
        english: {
            scoreRanges: {
                "200-220": "1st",
                "221-240": "5th",
                "241-260": "10th",
                "261-280": "20th",
                "281-300": "35th",
                "301-320": "50th",
                "321-340": "68th",
                "341-360": "82nd",
                "361-380": "92nd",
                "381-400": "98th",
            },
            averageScore: 529,
        },
        math: {
            scoreRanges: {
                "200-220": "1st",
                "221-240": "5th",
                "241-260": "12th",
                "261-280": "22nd",
                "281-300": "38th",
                "301-320": "55th",
                "321-340": "72nd",
                "341-360": "85th",
                "361-380": "94th",
                "381-400": "98th",
            },
            averageScore: 499,
        },
        totalAverageScore: 1028,
    };

    // MAPS (example usage)
    const mcqIdToNameMap = {};
    const frqIdToNameMap = {};
    (esubjects || []).forEach((s) => {
        (s.subTopics || []).forEach((st, i) => {
            mcqIdToNameMap[i] = st.name;
        });
    });
    (msubjects || []).forEach((s) => {
        (s.subTopics || []).forEach((st, i) => {
            frqIdToNameMap[i] = st.name;
        });
    });

    // 일반 AI 질문 처리
    useEffect(() => {
        if (aiquestion && aiquestion.trim() !== "") {
            if (!aiplayed) {
                setaiplayed(true);
            }

            const handleaiquestionysis = async () => {
                try {
                    // First add the user's question
                    const userMessage = {
                        role: "user",
                        content: "Based on the SAT information provided, could you analyze the following aspects?"
                    };

                    setMessages(prev => [...prev, userMessage]);

                    // Call askai and wait for the response
                    const recentMessages = [...messages, userMessage];
                    await askai(aiquestion, 800, recentMessages, false);

                    // Set visual mode after we're sure we have the response
                    setvisual(2);
                } catch (error) {
                    console.error("Error in SAT analysis:", error);
                    setvisual(0); // Reset visual mode if there's an error
                }
            };

            handleaiquestionysis();
        }
    }, [aiquestion]);

    // SAT 분석(satanal) 처리: visual 모드를 1로 설정하여 SATScoreAnalysis 렌더링
    useEffect(() => {
        if (satanal && satanal.trim() !== "") {
            if (!aiplayed) {
                setaiplayed(true);
            }

            const handleSatAnalysis = async () => {
                try {
                    // First add the user's question
                    const userMessage = {
                        role: "user",
                        content: "Based on the SAT information provided, could you analyze the following aspects?"
                    };

                    setMessages(prev => [...prev, userMessage]);

                    // Call askai and wait for the response
                    const recentMessages = [...messages, userMessage];
                    await askai(satanal, 800, recentMessages, false);

                    // Set visual mode after we're sure we have the response
                    setvisual(1);
                } catch (error) {
                    console.error("Error in SAT analysis:", error);
                    setvisual(0); // Reset visual mode if there's an error
                }
            };

            handleSatAnalysis();
        }
    }, [satanal]);

    // mocksatreview 처리 (일반 텍스트 응답)
    useEffect(() => {
        if (mocksatreview && mocksatreview.trim() !== "") {
            if (!aiplayed) {
                setaiplayed(true);
            }

            const handlemocksatreviewysis = async () => {
                try {
                    // First add the user's question
                    const userMessage = {
                        role: "user",
                        content: "Please analysis this SAT Result."
                    };

                    setMessages(prev => [...prev, userMessage]);

                    // Call askai and wait for the response
                    const recentMessages = [...messages, userMessage];
                    await askai(mocksatreview, 800, recentMessages, false);

                    // Set visual mode after we're sure we have the response
                    setvisual(3);
                } catch (error) {
                    console.error("Error in SAT analysis:", error);
                    setvisual(0); // Reset visual mode if there's an error
                }
            };

            handlemocksatreviewysis();
        }
    }, [mocksatreview]);

    // 최초 analai 저장
    useEffect(() => {
        if (analai && analai.trim() !== "" && initialAnalai === "") {
            setInitialAnalai(analai);
        }
    }, [analai, initialAnalai]);

    // 메시지 업데이트 시 스크롤 자동 이동
    useEffect(() => {
        if (messageEndRef.current) {
            messageEndRef.current.scrollIntoView({ behavior: "smooth" });
        }
    }, [messages]);

    // 주기적으로 툴팁 표시
    useEffect(() => {
        const interval = setInterval(() => {
            setShowTooltip(true);
            setTimeout(() => setShowTooltip(false), 2000);
        }, Math.random() * 3000 + 2000);
        return () => clearInterval(interval);
    }, []);

    /** Ask AI via your backend */
    const askai = async (systemPrompt, token, chatHistory, update) => {
        setIsLoading(true);
        try {
            const recentMessages = chatHistory.slice(-10);
            const historyText = recentMessages
                .map((m) => `${m.role === "user" ? "User:" : "AI:"} ${m.content}`)
                .join("\n");

            const finalPrompt = `
                ${systemPrompt}
                Below is the recent conversation:
                ${historyText}
                Please respond as instructed above.
                The Response needs to be within 400 tokens.
            `;

            const res = await axios.post(`${BASELINE}askai2`, {
                prompt: finalPrompt.trim(),
                token: token,
                u_id: user?.u_id,
                update: update,
                conversation_id: aiid
            }, { timeout: 30000 });

            if (res.data && res.data.message) {
                const answer = res.data.message.trim();
                setanalai(answer);

                try {
                    const parsedData = JSON.parse(answer);
                    setCurrentResponse(parsedData);
                    setMessages(prev => [...prev, {
                        role: "ai",
                        content: answer,
                        parsedData: parsedData
                    }]);
                } catch (e) {
                    setMessages(prev => [...prev, {
                        role: "ai",
                        content: answer
                    }]);
                }
            }
        } catch (error) {
            console.error("Error during API call:", error);
            setMessages(prev => [...prev, {
                role: "ai",
                content: "Sorry, I'm having trouble responding right now. Please try again."
            }]);
        } finally {
            setIsLoading(false);
        }
    };

    /**
     * When user clicks the floating chat icon:
     * - If not premium, open paywall.
     * - Otherwise, fetch old messages, greet if not done yet, and open chat.
     */
    const handleOpenAI = async () => {
        if (user.premium === 0) {
            setModalOpen(true);
            return;
        }
        setaiplayed(true);
        try {
            if (aiid) {
                const response = await axios.get(
                    `${BASELINE}messages?conversation_id=${aiid}`
                );
                if (response.data.success) {
                    setMessages(response.data.messages);
                }
            }
            if (!hasGreeted) {
                const systemPrompt = `
          You are Jaeon, the test coordinator. Please write a short, friendly greeting
          and an encouraging message to a student about to begin studying,
          in the tone of a supportive teacher.
          Student's first name: ${user.first_name}.
        `;
                await askai(systemPrompt, 45, messages, false);
                setHasGreeted(true);
                localStorage.setItem("hasGreeted", "true");
            }
        } catch (err) {
            console.error("Error in handleOpenAI:", err);
        }
    };

    const handleMacroMessage = async (macroType) => {
        let message = "";
        switch (macroType) {
            case "test":
                message = "Generate a practice test for me";
                break;
            case "analysis":
                message = "Analyze my SAT scores";
                break;
            default:
                return;
        }
        try {
            const updatedMessages = [...messages, { role: "user", content: message }];
            setMessages(updatedMessages);
            const scanResponse = await axios.post(`${BASELINE}trigger_scan`, {
                user_message: message,
            });
            switch (scanResponse.data.intentCode) {
                case 1:
                    const buttonMessage = {
                        role: "system",
                        content: "Would you like to proceed with creating a quiz?",
                        hasButtons: true,
                        buttons: [
                            { label: "AI Pick English Quiz!", action: "CREATE_QUIZ" },
                            { label: "AI Pick Math Quiz!", action: "CREATE_QUIZ" },
                        ],
                    };
                    setMessages((prev) => [...prev, buttonMessage]);
                    return;
                case 2:
                    const scoreMessage = {
                        role: "system",
                        content: "",
                        isScoreComparison: true,
                        scoreData: {
                            myScore: lastscore,
                            avgScore: avg_sat,
                            percentile: 85,
                        },
                    };
                    setMessages((prev) => [...prev, scoreMessage]);
                    return;
                default:
                    break;
            }
            const englishTopicsString = esubjects
                .flatMap((s) => s.subTopics)
                .map((st) => st.name)
                .join(", ");
            const mathTopicsString = msubjects
                .flatMap((s) => s.subTopics)
                .map((st) => st.name)
                .join(", ");
            let systemPrompt = "";
            if (subject === "SAT") {
                systemPrompt = `
       You are Jaeon, a friendly and supportive Digital SAT Test Coordinator. 
       Your goal is to provide personalized, encouraging, and actionable guidance to help students improve their SAT scores. 
       Use a warm, conversational tone and relate to the student's experiences. 
       Offer specific advice based on their scores and topics, and always maintain a positive, motivating attitude. Keep your responses concise (2-3 sentences) but impactful. 
       If the user's request is off-topic, gently redirect them to SAT-related discussions in a single, friendly sentence.
          <User Information>
            User Information: ${user}
            Last SAT Score: ${lastscore}
            Average SAT Score: ${avg_sat}
            Average SAT English Score: ${averageMCQ}
            Average SAT Math Score: ${averageFRQ}
            SAT English Topics: ${englishTopicsString}
            SAT Math Topics: ${mathTopicsString}
          </User Information>
        `;
            } else if (subject === "SAT89") {
                systemPrompt = `
          You are Jaeon, a Digital SAT 8 & 9 Test Coordinator who provides specific, friendly,
          and concise guidance (2–3 sentences max). 
          Do not greet the user again. 
          If the user's request is off-topic, respond politely in 1 short sentence. 
          <User Information>
            Last SAT 8 & 9 Score: ${lastscore}
            Average SAT 8 & 9 Score: ${avg_sat}
            Average SAT 8 & 9 English Score: ${averageMCQ}
            Average SAT 8 & 9 Math Score: ${averageFRQ}
            SAT 8 & 9 English Topics: ${englishTopicsString}
            SAT 8 & 9 Math Topics: ${mathTopicsString}
          </User Information>
        `;
            } else if (subject === "SAT10") {
                systemPrompt = `
          You are Jaeon, a Digital NMSQT Test Coordinator who provides specific, friendly,
          and concise guidance (2–3 sentences max). 
          Do not greet the user again. 
          If the user's request is off-topic, respond politely in 1 short sentence. 
          <User Information>
            Last NMSQT Score: ${lastscore}
            Average NMSQT Score: ${avg_sat}
            Average NMSQT English Score: ${averageMCQ}
            Average NMSQT Math Score: ${averageFRQ}
            NMSQT English Topics: ${englishTopicsString}
            NMSQT Math Topics: ${mathTopicsString}
          </User Information>
        `;
            } else if (subject === "CALCAB") {
                systemPrompt = `
      You are Jaeon, a Digital AP Calculus AB Test Coordinator who gives friendly and encouraging guidance.
      Only provide AP Calculus AB study advice if the user explicitly asks about studying, Digital AP Calculus AB exams, or related topics.
      If the user just greets or says something unrelated, respond briefly and warmly, without going into detail.
      Keep your answers concise (no more than 2-3 sentences).
      <User Information>
        Last Digital AP Calculus AB Score: ${lastscore}
        Average Digital AP Calculus AB Score: ${avg_sat}
        Average Digital AP Calculus AB MCQ Score: ${averageMCQ}
        Average Digital AP Calculus AB FRQ Score: ${averageFRQ}
        Digital AP Calculus AB MCQ Topics: ${englishTopicsString}
        Digital AP Calculus AB FRQ Topics: ${mathTopicsString}
      </User Information>
    `;
            }
            await askai(systemPrompt, 150, updatedMessages, true);
        } catch (err) {
            console.error("Error in handleMacroMessage:", err);
        }
    };

    /** Send chat message to AI */
    const handleSendMessage = async () => {
        const trimmed = userin.trim();
        if (!trimmed) return;

        const newMessage = {
            conversation_id: aiid,
            role: "user",
            content: trimmed,
            u_id: user?.u_id,
        };

        try {
            // Save user message to DB
            const saveResponse = await axios.post(`${BASELINE}messages`, newMessage);
            if (!saveResponse.data.success) {
                console.error("Failed to save message:", saveResponse.data);
                return;
            }
            const updatedMessages = [...messages, { role: "user", content: trimmed }];
            setMessages(updatedMessages);
            setuserin("");
            // Reset visual flag to 0 (plain rendering)
            setvisual(0);

            // check if user wants a quiz
            const scanResponse = await axios.post(`${BASELINE}trigger_scan`, {
                user_message: trimmed,
            });

            switch (scanResponse.data.intentCode) {
                case 1:
                    const buttonMessage = {
                        role: "system",
                        content: "Would you like to proceed with creating a quiz?",
                        hasButtons: true,
                        buttons: [
                            { label: "AI Pick English Quiz!", action: "CREATE_QUIZ" },
                            { label: "AI Pick Math Quiz!", action: "CREATE_QUIZ" },
                        ],
                    };
                    setMessages((prev) => [...prev, buttonMessage]);
                    return;
                case 2:
                    const scoreMessage = {
                        role: "system",
                        content: "Analysis based on 2024 National SAT Statistics",
                        isScoreComparison: true,
                    };
                    setMessages((prev) => [...prev, scoreMessage]);
                    return;
                case 0:
                default:
                    break;
            }

            const englishTopicsString = esubjects
                .flatMap((s) => s.subTopics)
                .map((st) => st.name)
                .join(", ");
            const mathTopicsString = msubjects
                .flatMap((s) => s.subTopics)
                .map((st) => st.name)
                .join(", ");

            let systemPrompt = "";
            if (subject === "SAT") {
                systemPrompt = `
       You are Jaeon, a friendly and supportive Digital SAT Test Coordinator. 
       Your goal is to provide personalized, encouraging, and actionable guidance to help students improve their SAT scores. 
       Use a warm, conversational tone and relate to the student's experiences. 
       Offer specific advice based on their scores and topics, and always maintain a positive, motivating attitude. Keep your responses concise (2-3 sentences) but impactful. 
       If the user's request is off-topic, gently redirect them to SAT-related discussions in a single, friendly sentence.
          <User Information>
            User Information: ${user}
            Last SAT Score: ${lastscore}
            Average SAT Score: ${avg_sat}
            Average SAT English Score: ${averageMCQ}
            Average SAT Math Score: ${averageFRQ}
            SAT English Topics: ${englishTopicsString}
            SAT Math Topics: ${mathTopicsString}
          </User Information>
        `;
            } else if (subject === "SAT89") {
                systemPrompt = `
          You are Jaeon, a Digital SAT 8 & 9 Test Coordinator who provides specific, friendly,
          and concise guidance (2–3 sentences max). 
          Do not greet the user again. 
          If the user's request is off-topic, respond politely in 1 short sentence. 
          <User Information>
            Last SAT 8 & 9 Score: ${lastscore}
            Average SAT 8 & 9 Score: ${avg_sat}
            Average SAT 8 & 9 English Score: ${averageMCQ}
            Average SAT 8 & 9 Math Score: ${averageFRQ}
            SAT 8 & 9 English Topics: ${englishTopicsString}
            SAT 8 & 9 Math Topics: ${mathTopicsString}
          </User Information>
        `;
            } else if (subject === "SAT10") {
                systemPrompt = `
          You are Jaeon, a Digital NMSQT Test Coordinator who provides specific, friendly,
          and concise guidance (2–3 sentences max). 
          Do not greet the user again. 
          If the user's request is off-topic, respond politely in 1 short sentence. 
          <User Information>
            Last NMSQT Score: ${lastscore}
            Average NMSQT Score: ${avg_sat}
            Average NMSQT English Score: ${averageMCQ}
            Average NMSQT Math Score: ${averageFRQ}
            NMSQT English Topics: ${englishTopicsString}
            NMSQT Math Topics: ${mathTopicsString}
          </User Information>
        `;
            } else if (subject === "CALCAB") {
                systemPrompt = `
      You are Jaeon, a Digital AP Calculus AB Test Coordinator who gives friendly and encouraging guidance.
      Only provide AP Calculus AB study advice if the user explicitly asks about studying, Digital AP Calculus AB exams, or related topics.
      If the user just greets or says something unrelated, respond briefly and warmly, without going into detail.
      Keep your answers concise (no more than 2-3 sentences).
      <User Information>
        Last Digital AP Calculus AB Score: ${lastscore}
        Average Digital AP Calculus AB Score: ${avg_sat}
        Average Digital AP Calculus AB MCQ Score: ${averageMCQ}
        Average Digital AP Calculus AB FRQ Score: ${averageFRQ}
        Digital AP Calculus AB MCQ Topics: ${englishTopicsString}
        Digital AP Calculus AB FRQ Topics: ${mathTopicsString}
      </User Information>
    `;
            }
            askai(systemPrompt, 150, updatedMessages, true);
        } catch (err) {
            console.error("Error saving message or calling askai:", err);
        }
    };

    return (
        <div>
            {/* Promotion / Premium Modal */}
            <PromotionModal isOpen={modalOpen} onClose={() => setModalOpen(false)} />

            {/* Floating AI Button (if chat is closed) */}
            {!aiplayed && (
                <motion.div
                    className="fixed bottom-4 right-4 w-16 h-16 flex items-center justify-center bg-purple-600 text-white text-2xl shadow-lg cursor-pointer rounded-[18px]"
                    onClick={handleOpenAI}
                    whileHover={{ scale: 1.05 }}
                >
                    <FaComments />
                </motion.div>
            )}

            {/* Chat Window */}
            {aiplayed && (
                <motion.div
                    className="
        fixed bottom-0 right-0 sm:bottom-4 sm:right-4
        w-full max-w-[550px] h-[80vh] md:h-[700px]
        flex flex-col
        rounded-lg border border-[#3b3b3b]
        bg-[#1a1a1a]/90 text-slate-100
        shadow-xl overflow-hidden z-[100]
      "
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: 10 }}
                    transition={{ duration: 0.5 }}
                >
                    {/* Header */}
                    <div className="flex items-center justify-between px-3 py-2 bg-[#2b2b2b] border-b border-[#3b3b3b]">
                        <span className="text-base font-bold">AI Assistant</span>
                        <FaAngleDoubleDown
                            className="cursor-pointer hover:opacity-80"
                            onClick={() => setaiplayed(false)}
                        />
                    </div>

                    {/* Messages */}
                    <div className="flex-grow overflow-y-auto p-3 space-y-3 no-scrollbar">
                        {messages.map((m, i) => {
                            const isUser = m.role === "user";
                            const alignmentClass = isUser ? "justify-end" : "justify-start items-start";
                            const bubbleClass = isUser ? "bg-blue-600 text-white" : "bg-[#2a2a2a] text-[#87bfff]";
                            const showAvatar = !isUser;

                            // Only try to parse JSON for AI messages when visual mode is enabled
                            let analysisData = null;
                            if (!isUser && visual === 1 && m.content) {
                                try {
                                    analysisData = JSON.parse(m.content);
                                } catch (e) {
                                    // If parsing fails, we'll render as normal text
                                    //console.log("Not JSON content:", e);
                                }
                            }

                            return (
                                <div key={i} className={`flex w-full ${alignmentClass}`}>
                                    {showAvatar && (
                                        <img
                                            src="/dashboard/jaeon_avatar.png"
                                            alt="Jaeon"
                                            className="w-8 h-8 rounded-full mr-2 mt-1"
                                        />
                                    )}
                                    <div className={`relative px-3 py-2 rounded-lg ${m.parsedData ? "max-w-[90%] w-full" : "max-w-[75%]"
                                        } ${bubbleClass}`}>
                                        {isLoading && i === messages.length - 1 ? (
                                            <div className="flex items-center space-x-2">
                                                <div className="animate-pulse">Processing...</div>
                                            </div>
                                        ) : !isUser ? (
                                            (() => {
                                                // JSON 파싱 및 유효성 검사 함수
                                                const isValidJSON = (data) => {
                                                    try {
                                                        return typeof data === 'object' && data !== null;
                                                    } catch {
                                                        return false;
                                                    }
                                                };

                                                // 각 컴포넌트에 필요한 데이터 구조 검증
                                                const isValidScoreAnalysis = (data) => (
                                                    data &&
                                                    typeof data === 'object' &&
                                                    data['Recent SAT Trend'] &&
                                                    data['Score Review'] &&
                                                    data['Study Pathway'] &&
                                                    data['College Rank']
                                                );

                                                const isValidPredictionAnalysis = (data) => (
                                                    data &&
                                                    typeof data === 'object' &&
                                                    data.studyTimeRequired &&
                                                    data.achievabilityRate &&
                                                    data.furtherGrowthPotential
                                                );

                                                const isValidScoreDisplay = (data) => (
                                                    data &&
                                                    typeof data === 'object' &&
                                                    data['SAT difficulty'] &&
                                                    data['MY SAT SCORE'] &&
                                                    data['English priority Topics'] &&
                                                    data['Math priority Topics']
                                                );

                                                if (!m.parsedData || !isValidJSON(m.parsedData)) {
                                                    return <p className="text-sm whitespace-pre-line mb-[5px]">{m.content}</p>;
                                                }

                                                // 데이터 구조에 따른 컴포넌트 렌더링
                                                if (visual === 1 && isValidScoreAnalysis(m.parsedData)) {
                                                    return <SATScoreAnalysis analysisData={m.parsedData} />;
                                                } else if (visual === 2 && isValidPredictionAnalysis(m.parsedData)) {
                                                    return <SATPredictionAnalysis analysisData={m.parsedData} />;
                                                } else if (visual === 3 && isValidScoreDisplay(m.parsedData)) {
                                                    return <SATScoreDisplay scoreData={m.parsedData} />;
                                                } else {
                                                    return <p className="text-sm whitespace-pre-line mb-[5px]">Closed...</p>;
                                                }
                                            })()
                                        ) : (
                                            <p className="text-sm whitespace-pre-line mb-[5px]">{m.content}</p>
                                        )}
                                        {/* Quiz creation buttons */}
                                        {m.hasButtons && m.buttons && (
                                            <div className="flex flex-col gap-2 mt-2">
                                                {m.buttons.map((btn, idx) => (
                                                    <button
                                                        key={idx}
                                                        className="px-3 py-1 bg-blue-700 text-white rounded hover:bg-blue-800"
                                                    >
                                                        {btn.label}
                                                    </button>
                                                ))}
                                            </div>
                                        )}
                                        {m.isScoreComparison && (
                                            <div className="w-full bg-gray-800 rounded-lg p-4">
                                                <ScoreAnalysis
                                                    satData={satData2024}
                                                    avg_sat={avg_sat}
                                                    averageeng={averageMCQ}
                                                    averagemath={averageFRQ}
                                                />
                                            </div>
                                        )}
                                    </div>
                                </div>
                            );
                        })}
                        <div ref={messageEndRef} />
                    </div>

                    {/* Input Area */}
                    <div className="w-full p-2 bg-[#2b2b2b] border-t border-[#3b3b3b]">
                        <div className="flex gap-2 mb-2 px-1">
                            <button
                                onClick={() => handleMacroMessage("test")}
                                className="
            px-3 py-1.5
            bg-[#1a1a1a]
            hover:bg-[#252525]
            text-gray-300
            text-sm
            rounded-full
            border border-[#3b3b3b]
            transition-colors
        "
                            >
                                Make an AI test
                            </button>
                            <button
                                onClick={() => handleMacroMessage("analysis")}
                                className="
            px-3 py-1.5
            bg-[#1a1a1a]
            hover:bg-[#252525]
            text-gray-300
            text-sm
            rounded-full
            border border-[#3b3b3b]
            transition-colors
        "
                            >
                                Analyze my SAT data
                            </button>
                        </div>
                        <div className="flex items-center space-x-2">
                            <input
                                className="
                flex-grow
                bg-[#1a1a1a]
                rounded-[30px]
                px-3 py-2
                text-gray-100
                placeholder-gray-400
                focus:outline-none focus:ring-2 focus:ring-[#87bfff]
            "
                                value={userin}
                                onChange={(e) => setuserin(e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        handleSendMessage(userin);
                                    }
                                }}
                                placeholder="Type your message..."
                            />
                            <button
                                onClick={() => handleSendMessage(userin)}
                                className="
                bg-gray-800
                text-white
                text-[18px]
                font-semibold
                rounded-[30px]
                transition
                p-2
            "
                            >
                                <IoIosSend />
                            </button>
                        </div>
                    </div>
                </motion.div>
            )}
        </div>
    );
};

export default DashboardAI;
